import { render, staticRenderFns } from "./ActionsOverview.vue?vue&type=template&id=31673d68"
import script from "./ActionsOverview.vue?vue&type=script&lang=ts"
export * from "./ActionsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports